module.exports = __webpack_public_path__ + "static/media/(DH)-Artesanato-25.b2806d47.jpg";